<script setup>
import ticker from "@/components/App/ticker.vue";
import headerDefault from "@/components/App/header-default/header-default.vue";
import footerDefault from "@/components/App/footer/footer.vue";
import headImageComponent from "@/components/App/head-image.vue";
import squaredImage from "@/components/App/squared-image.vue";
import productOption from "@/components/App/product-option.vue";
import similarProductsComponent from "@/components/App/similar-products.vue";

import {
    ref,
    reactive,
    computed,
    onBeforeMount,
    onMounted,
    onBeforeUnmount,
    watch,
    inject,
    useTemplateRef,
    onUpdated,
    nextTick,
    onUnmounted
} from 'vue';
import { useCommonComposable } from '@/composables/commonComposable.js';
import { useStore } from 'vuex';
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router';
import { useHead } from "@vueuse/head";
import ProductTips from "@/views/App/ProductItem/components/product-tips.vue";
import Accordeon from "@/components/App/accordeon.vue";
import Preloader from "@/components/App/preloader.vue";
import ModalTip from "@/components/App/modal-tip.vue";
const notify = inject('notify');

const store = useStore();
const router = useRouter();
const route = useRoute();

const { setImageURL, setImageThumbURL, removeTooltips, isMobile } = useCommonComposable();

const buyBtn = useTemplateRef('buyBtn')

const isLoadingPage = ref(true);

const minImageHeight = ref(null); // Здесь будет храниться единая высота

// Функция для вычисления минимальной ширины
const updateGalleryHeight = () => {
    // Ищем все элементы с классом .img-elem (контейнеры картинок)
    const imageWrappers = document.querySelectorAll('.img-elem');

    if (imageWrappers.length > 0) {
        // Получаем массив ширин и ищем минимальное значение
        const widths = Array.from(imageWrappers).map(el => el.offsetWidth);
        const minWidth = Math.min(...widths);

        minImageHeight.value = minWidth;
    }
};

const fetchParams = ref({})
const localImages = ref()
const actProduct = ref({'Команда': '«Команда» (Россия)'})

const similarProducts = ref([])

const accordeons = ref([
    {
        name: 'delivery-conditions',
        header: 'Условия доставки',
        text: '<p>Отправляем заказ в течение трёх рабочих дней с момента оформления. Срок доставки зависит от выбора службы доставки и расстояния. Возврат осуществляется в соответствии с законом РФ «О защите прав потребителей». <a href="/pages/offer">Оферта</a></a></p>',
        link: '',
        color: ''
    },
    {
        name: 'wash-tips',
        header: 'Советы по уходу',
        text: '<p></p>',
        link: `${process.env.VUE_APP_SERVER_URL.replace(/\\\\/g, '/')}/api/pdf/How-to-wash-football-jersey-ballershop.ru.pdf`,
        color: '',
    },
    // {
    //     name: 'social',
    //     header: 'Связаться в Telegram',
    //     text: '<p></p>',
    //     link: 'https://t.me/ballermanager',
    //     color: 'rgba(39,167,231,0.2)'
    // }
])

const isSoldOut = computed(() => {
    if (!actProduct.value["Статус"]) return false
    return actProduct.value["Статус"] === "Archived";
})

const actualProduct = computed(() => {
    return store.state.product.actualProduct;
})

const headImage = computed(() => {
    try {
        return localImages.value.find(image => image["Тип"] === 'Заглавная')
    } catch (e) {}
})

const otherImages = computed(() => {
    try {
        return localImages.value.find(image => image["Тип"] === 'Заглавная')
    } catch (e) {}
})

const setLocalImages = computed(() => {
    return store.state.images;
})

const setClipBuy = computed(() => {
    // Реализация необычной формы кнопки

    const btn = buyBtn.value
    const height = parseInt(getComputedStyle(btn).height);
    const width = parseInt(getComputedStyle(btn).width);
    const pr = height/width

    let bph = 4; /* border percent height */
    let bpw = pr * bph
    let o = 2.5; /* otklonenie */

    let ILT = `${0 + (width/100*bpw)}px ${0 + (height/100*bph)}px`;
    let ILB = `${0 + (width/100*bpw)}px ${height - (height/100*bph)}px`;
    let OLM = `${0}px ${height - (height/100*bph)}px`;
    let OLT = `${0}px ${0}px`;
    let ORT = `${width}px ${0}px`;
    let ORB = `${width - (width/100*o)}px ${height}px`;
    let OLB = `${0}px ${height}px`;
    // OLM
    let IRB = `${width - (width/100*bpw) - (width/100*o)}px ${height - (height/100*bph)}px`;
    let IRT = `${width - (width/100*bpw)}px ${0 + (height/100*bph)}px`;
    // ILT

    return `polygon(${ILT}, ${ILB}, ${OLM}, ${OLT}, ${ORT}, ${ORB}, ${OLB}, ${OLM}, ${IRB}, ${IRT}, ${ILT})`
})

const isAdded = computed(() => {
    if (actProduct.value["Код"]) {
        if (store.state.cart.items.findIndex(item => item["Код"] === actProduct.value["Код"]) === -1) {
            return false
        }
        return true
    }
    return false
})

// methods

const setImageAlt = (obj) => {
    if (obj) {
        return obj['Текст']
    } else {
        return ''
    }
}

const setHeadImage = (id) => {
    for (let image of localImages.value) {
        if (image["Тип"] === "Заглавная") {
            image["Тип"] = "Обычная"
        }
        if (image["ID"] === id) {
            image["Тип"] = "Заглавная"
        }
    }
}

const moveForward = () => {
    const index = localImages.value.findIndex(item => item["Тип"] === 'Заглавная');

    if (index !== -1 && index + 1 < localImages.value.length) {
        if (Object.hasOwn(localImages.value[index + 1], 'img')) {
            setHeadImage(localImages.value[0]["ID"]);
        } else {
            setHeadImage(localImages.value[index + 1]["ID"]);
        }
    } else {
        setHeadImage(localImages.value[0]["ID"]);
    }
}

const moveBack = () => {
    const index = localImages.value.findIndex(item => item["Тип"] === 'Заглавная');

    /* обработка фиктивных изображений в очереди (для целостности сетки) */
    if (index-1<0) {
        if (Object.hasOwn(localImages.value[localImages.value.length-2], 'img')) {
            setHeadImage(localImages.value[localImages.value.length-3]["ID"])
            return
        }
        if (Object.hasOwn(localImages.value[localImages.value.length-1], 'img')) {
            setHeadImage(localImages.value[localImages.value.length-2]["ID"])
            return
        }
    }

    if (index !== -1 && (index - 1) >= 0) {
        setHeadImage(localImages.value[index - 1]["ID"]);
    } else {
        setHeadImage(localImages.value[localImages.value.length-1]["ID"]);
    }
}

const fetchData = async () => {
    // Локальная копия картинок для изменения их типов и => отображения во front-end

    fetchParams.value = {code: route.params.code}
    await store.dispatch(`product/fetchActualProduct`, fetchParams.value);
    fetchParams.value = {productCode: route.params.code}
    await store.dispatch(`fetchImages`, fetchParams.value);
    localImages.value = setLocalImages.value

    /* добавление фиктивной картинки */
    if (localImages.value.length > 0 && localImages.value.length % 3 === 1) {
        localImages.value.push({img: null}, {img: null})
    }
    if (localImages.value.length > 0 && localImages.value.length % 3 === 2) {
        localImages.value.push({img: null})
    }

    actProduct.value = store.state.product.actualProduct[0]

    if (!actProduct.value) {
        await router.replace({ name: 'not-found' });
    }

    fetchParams.value = {
        code: actProduct.value["Код"],
        team: actProduct.value['Команда'].replace(/\(([^)]+)\)/, '').trim(),
        country: actProduct.value['Команда'].match(/\(([^)]+)\)/)[1]
    }
    await store.dispatch(`product/fetchSimilarProducts`, fetchParams.value)
    similarProducts.value = store.state.product.similarProducts

    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });

    useHead({
        title: `${actProduct.value['Название продукта']} — Baller | Оригинальные джерси`,
        meta: [
            {name: 'description', content: `Baller — магазин оригинальных джерси: от 30-летнего винтажа до модных футболок. ${actProduct.value['Название продукта']} купить по доступной цене`},
            {name: 'robots', content: 'noindex, nofollow'},
            {property: 'og:title', content: `${actProduct.value['Название продукта']} — Baller | Оригинальные джерси`},
            {property: 'og:description', content: `Baller — магазин оригинальных джерси: от 30-летнего винтажа до модных футболок. ${actProduct.value['Название продукта']} купить по доступной цене`},
            {property: 'og:image', content: `${headImage.value ? setImageURL(headImage.value) : ''}`},
            {property: 'og:url', content: `${window.location.origin + route.fullPath}`},
            {property: 'og:type', content: `article`},
            {property: 'og:image:type', content: 'image/png'}
        ],
    })
}

const addToCart = () => {
    if (isSoldOut.value) return
    store.commit('ADD_TO_CART', { item: actProduct.value, quantity: 1 })
    notify('Товар добавлен в корзину')
}
const setBuyNow = () => {
    if (isSoldOut.value) return
    store.commit('SET_BUY_NOW', actProduct.value)
    router.push({path: '/checkout'})
}

const copyProductCode = async (code) =>{
    try {
        await navigator.clipboard.writeText(code);
        notify(`Добавлено в буфер обмена`)
    } catch (e) {
        return
    }
}

const isShowTipModal = ref(false);
const headerTipModal = ref('Заголовок')
const contentTipModal = ref('Текст')
const tipModals = ref([
    {
        id: 'original-quality',
        header: 'Оригинальная джерси — убедись сам',
        content: '<p>На нашем сайте отобраны только аутентичные вещи: это можно проверить, например, по биркам, крою, нашивкам, вышивке логотипов. Напиши нам, если есть сомнения, — предоставим дополнительные фото. Или просто оформи заказ, убедись на месте и оформи возврат, если что-то пошло не так. Главное сохранить товар в том же состоянии.</p><p class="tip"><i>Совет: проводим поверхностный легит-чек по фото. </i>Найди на другом сайте (например, Ebay) такую же вещь — и просто сравни: положение логотипов, нашивок и бирок, их размеры и способ нанесения. Если вещь новая, у топ-брендов всегда есть бирка с номером модели — просто вбей его в поиск. Большинство реплик «прокалываются» уже на этом этапе.</p>',
        img: 'barcode.png',
        alt: 'Штрих-код (изображение)'
    },
    {
        id: 'order-steps',
        header: 'Как мы оформим заказ: пять шагов',
        content:
            `
            <div class="stp-item">
                <p class="number">1.</p>
                <p>Добавь товар в корзину или нажми на кнопку «Купить сейчас»</p>
            </div>
            <div class="stp-item">
                <p class="number">2.</p>
                <p>Перейди на страницу оформления заказа и прямо там введи свои данные для отправки. Мы сразу укажем примерный срок доставки</p>
            </div>
            <div class="stp-item">
                <p class="number">3.</p>
                <p>После оплаты на сайте, отправим заказ в течение трёх дней. Надёжно упакуем в курьерский пакет и зип-лок</p>
            </div>
            <div class="stp-item">
                <p class="number">4.</p>
                <p>Получение — в пункте выдачи. Детальную информацию о пути посылки можно найти в приложении Яндекс Go</p>
            </div>
            <div class="stp-item">
                <p class="number">5.</p>
                <p>Напиши нам в сообщения в любой из соцсетей или на почту <a href="mailto:hello@ballershop.ru">hello@ballershop.ru</a>, если появится вопрос</p>
            </div>
            <style>div.stp-item {display: flex; gap: 15px; } p.number {min-width: 10%; align-items: center; display: flex; justify-content: center; font-size: 25px; color: #DC33DF}</style>
            `,
        img: 'five.png',
        alt: 'Цифра «5» (изображение)'
    }
])

const getImg = (src) => {
    return require(`./assets/${src}`) || ''
}

const openTipModal = (e, item) => {
    e.preventDefault()
    console.log(e.currentTarget)
    isShowTipModal.value = true;
    headerTipModal.value = item.header
    contentTipModal.value = item.content
}

const closeTipModal = () => {
    console.log('closeTipModal')
    isShowTipModal.value = false
}

onMounted(async () => {
    await fetchData()
    await nextTick(() => {
        buyBtn.value.style.clipPath = setClipBuy.value
    })

    updateGalleryHeight()
    window.addEventListener('resize', updateGalleryHeight);

    isLoadingPage.value = false;
})

onUpdated(() => {
    localImages.value = setLocalImages.value
})

watch(() => route.params.code, (newValue, oldValue) => {
    if (newValue !== oldValue) {
        fetchData(newValue); // Получаем новые данные
    }
})

onUnmounted(async () => {
    window.removeEventListener('resize', updateGalleryHeight);
})

onBeforeRouteLeave( () => {
    removeTooltips()

    window.removeEventListener('resize', updateGalleryHeight);
})

</script>

<template>
    <preloader v-if="isLoadingPage" :is-loading="isLoadingPage"></preloader>
    <ticker></ticker>
    <header-default></header-default>
    <div class="container page product-page">
        <div class="row product-block">

            <div class="col-lg-6 col-md-6 col-12 product-images">
                <product-tips v-if="isMobile"></product-tips>
                <div class="head-image">
                    <head-image-component v-if="headImage" @update:back="moveBack" @update:forward="moveForward" :image-url="setImageURL(headImage)"></head-image-component>
                </div>
                <div :class="['other-images', localImages && localImages.length % 3 === 1 ? 'not-first' : '']">
                    <div :class="['img-elem', Object.hasOwn(i, 'img') ? 'none' : '', i['Тип'] === 'Заглавная' ? 'active' : '']" v-if="localImages" v-for="(i, ind) in localImages">
                        <squared-image v-if="!Object.hasOwn(i, 'img')" @update:image="setHeadImage" :common-height=minImageHeight :is-select=true :is-header="i['Тип'] === 'Заглавная'" :image-url="setImageThumbURL(i)" :image-id="i['ID']" :image-text="actProduct['Название продукта']" :image-index="ind"></squared-image>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12 product-profile">
                <product-tips v-if="!isMobile"></product-tips>
                <div class="head">
                    <div class="header-block">
                        <span class="product-code" @click="copyProductCode(actProduct['Код'])">{{ actProduct["Код"] }}</span>
                        <h2 class="product-header">{{ actProduct["Название продукта"] }}</h2>
                    </div>
                    <div class="sold-out" v-if="isSoldOut">
                        <p>Продано</p>
                    </div>
                    <div class="price-block">
                        <div class="sale-block" v-if="actProduct['Цена по скидке'] !== 0 && actProduct['Цена по скидке'] !== actProduct['Обычная цена']">
                            <p :class="['sale-price', isSoldOut ? 'sold-out-price' : '']">{{ actProduct['Цена по скидке'] }}&#8381;</p>
                            <p class="default-price">{{ actProduct['Обычная цена'] }}&#8381;</p>
                        </div>
                        <div class="default-block" v-else>
                            <p :class="['sale-price', isSoldOut ? 'sold-out-price' : '']">{{ actProduct['Обычная цена'] }}&#8381;</p>
                        </div>
                    </div>
                </div>
                <div :class="['action-buttons', isSoldOut ? 'sold-out-button' : '']">
                    <div :class="['cart-btn', 'btn']" @click="addToCart" v-if="!isAdded">
                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 3.93848H2L3.74233 16.9633H16.2556L18 3.93848Z" stroke="white" stroke-width="2"/>
                            <path d="M5.35218 4.41544L4.9043 1.03687H14.7314L14.5161 4.41544" stroke="white" stroke-width="2"/>
                        </svg>
                        <span>Добавить в корзину</span>
                    </div>
                    <router-link to="/checkout" class="cart-btn cart-btn-active btn" v-if="isAdded">
                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.0596 4.07129L17.3154 17.0957L17.1992 17.9629H2.93555L2.81934 17.0957L1.07715 4.07129L0.925781 2.93848H19.2109L19.0596 4.07129ZM8.22852 12.6416L6.01562 10.4463L4.95898 11.5107L7.70312 14.2314L8.23242 14.7568L8.76074 14.2305L15.1787 7.83203L14.6494 7.30078L14.1191 6.76953L8.22852 12.6416Z" fill="white"/>
                            <path d="M5.42053 4.41568L4.97266 1.03711H14.7998L14.5845 4.41568" stroke="white" stroke-width="2"/>
                        </svg>
                        <span>В корзине</span>
                    </router-link>
                    <div class="buy-btn btn" @click="setBuyNow">
                        <span>Купить сразу</span>
                        <div class="buy-btn-border" ref="buyBtn"></div>
                    </div>
                </div>
                <div class="product-options">
                    <product-option :option-value="actProduct['Бренд']" :option-head="'Бренд:'"></product-option>
                    <product-option :option-value="actProduct['Состояние']" :option-head="'Состояние:'"></product-option>
                    <product-option :option-value="actProduct['Команда'].match(/\(([^)]+)\)/)[1]" :option-head="'Страна (лига):'"></product-option>
                    <product-option :option-value="actProduct['Команда'].replace(/\(([^)]+)\)/, '').trim()" :option-head="'Команда:'"></product-option>
                    <product-option :option-value="actProduct['Сезон']" :option-head="'Сезон:'"></product-option>
                    <product-option :option-value="actProduct['Размер']" :option-head="'Размер:'"></product-option>
                    <product-option :option-value="actProduct['Описание']" :option-head="'Описание:'" :is-short=false></product-option>
                    <product-option :option-value="actProduct['Недостатки']" :option-head="'Состояние:'" :is-short=false></product-option>
                </div>

                <div class="order-badge-items">
                    <div v-for="item of tipModals" class="order-badge" @click="(event) => openTipModal(event, item)" :id="item.id">
                        <p>{{ item.header }}</p>
                        <img :src="getImg(item.img)" :alt="item.alt">
                    </div>
                </div>
                <div class="acc-block">
                    <div v-for="item of accordeons" class="acc-item-container">
                        <accordeon :name="item.name" :header="item.header" :text="item.text" :link="item.link" :color="item.color"></accordeon>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="similarProducts.length > 0">
            <similar-products-component :similar-products=similarProducts></similar-products-component>
        </div>
    </div>
    <modal-tip :is-show="isShowTipModal" :header="headerTipModal" :content="contentTipModal" @closeTipModal="closeTipModal"></modal-tip>
    <footer-default></footer-default>
</template>

<style scoped lang="scss" src="./style.scss"></style>